import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { STATIC_RESOURCE } from '@/utils/tools';
import { useI18n } from '@/i18n';

export default function Index() {
  const $t = useI18n('component.header.language');

  const items = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img style={{ width: 62, height: 62, margin: 'auto' }} src={`${STATIC_RESOURCE}/cp_gsp/header/minilogo.png`} alt={$t('CP GSP mini program')} />
          <div style={{ marginTop: 6 }}>{$t('CP GSP mini program')}</div>
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img style={{ width: 62, height: 62, margin: 'auto' }} src={`${STATIC_RESOURCE}/cp_gsp/home/CPQualityInspection.jpg`} alt={$t('CP Quality Inspection')} />
          <div style={{ marginTop: 6 }}>{$t('CP Quality Inspection')}</div>
        </div>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }}>
      <span className='header-dropdown-trigger' onClick={(e) => e.stopPropagation()}>
        <Space>{$t('Related Applications')}<DownOutlined /></Space>
      </span>
    </Dropdown>
  );
}